import style from "./style.module.scss";


export default function SingleImage({ style: pstyle }) {
    return <div className={style.singleImage}>
        <div className={style.desc}>
            Vhenga doet veel meer. Zo zitten wij in elkaar. Uw dromen laten uitkomen is onze specialiteit
            <div className={style.sign}>
                Phil for friends
            </div>
            {/* <div className={pstyle.link}>Deel uw droom</div> */}
        </div>
        <img src="/Images/team/singleimage.jpg" alt="member" />
    </div>
}